import { createComponentModifiers } from '@ui-system/modifiers';

const componentModifiers = createComponentModifiers(({ css }) => ({
  underline: css`
    text-decoration: underline;
  `,
}));

export default componentModifiers;
